import { IMAGES } from "@/lib/site";

const LocationSection = () => (
  <section className="py-20 bg-sand-50" data-testid="location-section">
    <div className="max-w-7xl mx-auto px-6 grid grid-cols-1 lg:grid-cols-12 gap-8 items-center">
      <div className="lg:col-span-5">
        <span className="text-xs font-mono-clean text-ocean-700 uppercase tracking-wider font-semibold">
          Location & Arrival
        </span>
        <h2 className="font-display text-3xl font-bold text-ocean-900 mt-2">
          Sorake Beach, Lagundri Bay
        </h2>
        <p className="text-sm text-fog mt-4 leading-relaxed">
          Sorake Beach, Lagundri Bay, South Nias, North Sumatra, Indonesia. We
          arrange direct pick-up from Binaka Airport (GNS) and manage board
          logistics across Medan and Padang.
        </p>
        <div className="mt-6 flex flex-col gap-2 text-xs font-mono-clean text-fog">
          <p>&bull; 2.5 hours by car from Binaka Airport (GNS)</p>
          <p>&bull; 1 minute walk to the main reef jump-off</p>
          <p>&bull; Scooter hire on-site for neighboring spots</p>
        </div>
      </div>
      <div className="lg:col-span-7">
        <div className="aspect-[16/9] rounded-2xl border border-sand-200 relative overflow-hidden">
          <img
            src={IMAGES.map}
            alt="Beachfront sun loungers at Raffiel Nias, Sorake Beach at sunset"
            loading="lazy"
            className="absolute inset-0 w-full h-full object-cover"
          />
          <div className="absolute inset-0 bg-ocean-900/30" />
          <div className="absolute inset-0 p-6 flex flex-col justify-between">
            <span className="text-xs font-mono-clean uppercase text-ocean-900 bg-white/80 px-3 py-1 rounded inline-block w-max">
              Sorake Point · South Nias
            </span>
            <div className="p-4 rounded-xl bg-white/90 backdrop-blur max-w-sm">
              <p className="text-xs font-bold text-ocean-900">Raffiel Nias Surf Hotel</p>
              <p className="text-[11px] text-fog">Beachfront at Sorake Beach, Lagundri Bay</p>
            </div>
          </div>
        </div>
      </div>
    </div>
  </section>
);

export default LocationSection;
